module.exports = __webpack_public_path__ + "static/media/Online Store.0137bfae.svg";